import { Capacitor } from "@capacitor/core";

let pinnedBody: {
  position: string;
  top: string;
  left: string;
  right: string;
  scrollY: number;
  href: string;
} | null = null;

/**
 * Pin the page behind an open drawer in the iOS app, the way vaul already
 * does in mobile Safari. Vaul gates that on a "Safari" user agent, which
 * WKWebView doesn't send, so in the app the page under a drawer stayed
 * scrollable: focusing a drawer input (the comment composer over the feed)
 * let WebKit scroll the page to "reveal" it — and our Keyboard patch only
 * freezes that on pages that can't scroll — so the background jumped and
 * dragged the sheet with it. Pinned, the page can't scroll at all.
 */
export function pinBody() {
  if (pinnedBody || Capacitor.getPlatform() !== "ios") return;
  const { style } = document.body;
  pinnedBody = {
    position: style.position,
    top: style.top,
    left: style.left,
    right: style.right,
    scrollY: window.scrollY,
    href: window.location.href,
  };
  style.setProperty("position", "fixed", "important");
  style.top = `${-pinnedBody.scrollY}px`;
  style.left = "0px";
  style.right = "0px";
}

export function unpinBody() {
  if (!pinnedBody) return;
  const { style } = document.body;
  const { scrollY, href } = pinnedBody;
  style.position = pinnedBody.position;
  style.top = pinnedBody.top;
  style.left = pinnedBody.left;
  style.right = pinnedBody.right;
  pinnedBody = null;
  // A drawer link that navigated away owns the new page's scroll; only put
  // the reader back where they were on the page they never left.
  if (window.location.href === href) window.scrollTo(0, scrollY);
}

/**
 * The page's real vertical scroll, even while a drawer has it pinned (then
 * `window.scrollY` reads 0). Scroll capture must use this, or a navigation
 * started from inside a drawer remembers the top of the page.
 */
export function pageScrollY() {
  return pinnedBody ? pinnedBody.scrollY : window.scrollY;
}
